import {Component, inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import {ConfirmDialog} from '../../models/confirm-dialog';
import {MatIconModule} from '@angular/material/icon';
import {CloseableDialogComponent} from '../closeable-dialog/closeable-dialog.component';
import {ErrorCardComponent} from '../error-card/error-card.component';

@Component({
  selector: 'app-confirm-dialog',
  imports: [MatDialogModule, MatButtonModule, MatIconModule, CloseableDialogComponent, ErrorCardComponent],
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss'
})
export class ConfirmDialogComponent {
  private readonly dialogRef: MatDialogRef<ConfirmDialogComponent> = inject(MatDialogRef);
  readonly data: ConfirmDialog = inject<ConfirmDialog>(MAT_DIALOG_DATA);

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onDismiss(): void {
    this.dialogRef.close(false);
  }

  onWarningClick(): void {
    if (!this.data.warningButtonClick) {
      return;
    }
    this.data.warningButtonClick();
    this.dialogRef.close(false);
  }
}
